<template>
  <div>
    <view-title>
      <v-icon class="primary--text mr-4">fas fa-users</v-icon> Controle de usuários
      <template slot="button">
        <v-col class="text-right">
          <v-btn
            color="primary"
            rounded
            :to="{name: 'Usuário editar'}"
          >Adicionar</v-btn>
        </v-col>
      </template>
    </view-title>
    <simple-dialog
      title="Excluir"
      icon="fa-exclamation-triangle"
      :text="`Você tem certeza que deseja
                   excluir ${deleteItem.name} <${deleteItem.email}>?`"
      confirmText="Excluir"
      :dialog="deleteDialog"
      :on-dialog-input="onDeleteDialogInput"
      :on-confirm="onDelete"
    />
    <simple-dialog
      :title="blockItem.status ? 'Bloquear usuário' : 'Desbloquear usuário'"
      icon="fa-exclamation-triangle"
      :text="`Você tem certeza que deseja
                   ${blockItem.status ? 'bloquear' : 'desbloquear'}
                   ${blockItem.name} <${blockItem.email}>?`"
      :confirmText="`${blockItem.status ? 'Bloquear' : 'Desbloquear'}`"
      :dialog="blockDialog"
      :on-dialog-input="onBlockDialogInput"
      :on-confirm="onBlock"
    />
    <v-container>
      <v-row class="mx-5">
        <v-col />
        <v-col
          cols="12"
          md="8"
        >
          <v-text-field
            :value="search"
            append-icon="fas fa-search"
            label="Encontre um usuário"
            single-line
            outlined
            rounded
            @input="onInputSearch"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col />
      </v-row>
      <v-row class="mx-5">
        <v-col>
          <v-data-table
            :headers="headers"
            :items="accounts"
            :options="options"
            :loading="loading"
            :footer-props="footerProps"
            class="elevation-1"
          >
            <template v-slot:item.createdAt="{ item }">
              {{ formatDateAsDayMonthAndYear(item.createdAt) }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                v-if="item.status"
                label
                small
                color="success"
              >Ativo</v-chip>
              <v-chip
                v-else
                color="red"
                label
                dark
                small
              >Inativo</v-chip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                x-small
                class="mr-2"
                :to="{name: 'Usuário editar', params: {id: item.id}}"
              >
                <v-icon>fas fa-edit</v-icon>
              </v-btn>
              <v-icon
                small
                class="mr-2"
                @click="onBlockDialogOpen(item)"
              >
                {{ item.status ? 'fas fa-ban' : 'far fa-circle'}}
              </v-icon>
              <v-icon
                small
                @click="onDeleteDialogOpen(item)"
              >
                fas fa-trash
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import viewTitle from '@/components/view-title.vue';
import simpleDialog from '@/components/simple-dialog.vue';
import dateFormatter from '@/mixins/date-formatter';

export default {
  mixins: [dateFormatter],
  components: {
    viewTitle,
    simpleDialog,
  },
  computed: mapGetters('views/users/list', [
    'headers',
    'accounts',
    'totalAccounts',
    'loading',
    'options',
    'search',
    'footerProps',
    'deleteDialog',
    'deleteItem',
    'blockDialog',
    'blockItem',
  ]),
  methods: mapActions('views/users/list', [
    'afterRouteUpdate',
    'onInputSearch',
    'loadAccounts',
    'onDeleteDialogInput',
    'onDeleteDialogOpen',
    'onDelete',
    'onBlockDialogInput',
    'onBlockDialogOpen',
    'onBlock',
  ]),
  mounted() {
    this.loadAccounts({});
  },
};
</script>
